import axios from 'axios';
import moment from 'moment-timezone';
import store from '@/store';
import router from '@/router';
import vuetifyToast from '@/vuetifyToast';
// moment.tz.setDefault("America/New_York");
const env = process.env;

const request = function (packet) {
  return axios(packet)
    .then((response) => {
      return [response.data];
    })
    .catch((err) => {
      if (err && err.response && err.response.status && err.response.status === 401) {
        if (router.currentRoute.name !== 'login') {
          vuetifyToast.error(err.response.data.error.message);
          router.push({ name: 'login' });
        }
        return;
      }
      if (err && err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
        return [null, err.response.data.error.message];
      }
      return [null, err];
    });
};

// This is just a more complicated version of JSON.stringify()
function getDataFromObject(data) {
  let urlAdditions = '';

  if (Object.keys(data).length) {
    Object.keys(data).forEach((key) => {
      if (typeof data[key] == 'object') {
        urlAdditions += `&${key}=${encodeURIComponent(JSON.stringify(data[key]))}`;
      } else if (Array.isArray(data)) {
        // TODO: Not sure if this is how it consumes the data...
        urlAdditions += `&${key}=[${encodeURIComponent(data[key].toString())}]`;
      } else {
        urlAdditions += `&${key}=${encodeURIComponent(data[key])}`;
      }
    });
  }

  return urlAdditions;
}

function escapeCSVValue(value) {
  if (typeof value !== 'string') {
    return value;
  }

  value = value.replace(/"/g, '""');

  if (value.includes(',') || value.includes('"') || value.includes('\n') || value.includes('\r')) {
    return `"${value}"`;
  }

  return value;
}

export default class Trimaster {
  constructor(vm = {}) {
    Object.assign(this, vm);
  }

  static getDateTimeAsUtc(momentDate, user, tzPref) {
    // is date in local time or facility time?
    if (tzPref === 11) {
      // time is local-relative
      return momentDate.utc();
    } else if (tzPref === 12) {
      // time is facility-relative
      return moment.tz(momentDate, user.facility_timezone);
    }
  }

  formatDate(isoDate, datemask) {
    if (!datemask) {
      datemask = 'MM/DD/YYYY h:mm a';
    }
    if (!isoDate) {
      return '--';
    } else {
      return moment.tz(isoDate, store.getters['getUser'].facility_timezone).format(datemask);
    }
  }

  formatDateWithHTML(isoDate, format = 'MM/DD/YYYY h:mm a') {
    let innerVal, titleVal, retVal;

    // Local Time
    if (+this.$root.timePreference === 11) {
      innerVal =
        isoDate && moment(isoDate).isValid()
          ? `${moment.tz(moment.utc(isoDate), store.getters['getUser'].facility_timezone).format(format)}`
          : `--`;
      titleVal =
        isoDate && moment(isoDate).isValid()
          ? `${moment.tz(moment.utc(isoDate), moment.tz.guess()).format(format)}`
          : `--`;
      retVal = `<span title="Facilty Time: ${innerVal}">${titleVal}</span>`;
    } else if (+this.$root.timePreference === 12) {
      innerVal =
        isoDate && moment(isoDate).isValid()
          ? `${moment.tz(moment.utc(isoDate), moment.tz.guess()).format(format)}`
          : `--`;
      titleVal =
        isoDate && moment(isoDate).isValid()
          ? `${moment.tz(moment.utc(isoDate), store.getters['getUser'].facility_timezone).format(format)}`
          : `--`;
      retVal = `<span title="Your Local Time: ${innerVal}">${titleVal}</span>`;
    }
    return retVal;
  }

  formatDateWithHTMLSeconds(isoDate, format = 'MM/DD/YYYY h:mm:ss a') {
    let innerVal, titleVal, retVal;

    // Local Time
    if (+this.$root.timePreference === 11) {
      innerVal = isoDate ? `${moment.tz(isoDate, store.getters['getUser'].facility_timezone).format(format)}` : `--`;
      titleVal = isoDate ? `${moment.tz(isoDate, moment.tz.guess()).format(format)}` : `--`;
      retVal = `<span title="Facilty Time: ${innerVal}">${titleVal}</span>`;
    } else if (+this.$root.timePreference === 12) {
      innerVal = isoDate ? `${moment.tz(isoDate, moment.tz.guess()).format(format)}` : `--`;
      titleVal = isoDate ? `${moment.tz(isoDate, store.getters['getUser'].facility_timezone).format(format)}` : `--`;
      retVal = `<span title="Local Time: ${innerVal}">${titleVal}</span>`;
    }
    return retVal;
  }

  formatDateWithTZPref(isoDate, format = 'MM/DD/YYYY h:mm a') {
    if (!isoDate) {
      return '--';
    } else {
      return moment.tz(isoDate, this.tzPref()).format(format);
    }
  }

  tzPref() {
    if (+this.$root.timePreference === 12) {
      return store.getters['getUser'].facility_timezone;
    }
    return moment.tz.guess();
  }

  nowInTZPref() {
    return moment.tz(Date.now(), this.tzPref());
  }

  formatMinutesToHoursMinutes(minutesValue) {
    let hours = Math.floor(minutesValue / 60);
    let minutes = minutesValue % 60;
    minutes = minutes ? minutes + '' : minutes;
    return minutes ? hours + ':' + minutes.padStart(2, '0') : hours;
  }

  // keyboard filter for positive numbers
  static isNumber(evt) {
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
      evt.preventDefault();
    } else {
      return true;
    }
  }

  static timeDiff(t) {
    if (t && moment(t).isValid()) {
      return moment(t).fromNow();
    } else {
      return 'unknown';
    }
  }

  static get(uri, apitoken, data = {}) {
    if (uri[0] === '/') {
      uri = uri.substr(1);
    }

    const packet = {
      data,
      method: 'GET',
      url: `${env.VUE_APP_trimaster}/api/v1/${uri}?access_token=${apitoken}`,
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${apitoken}`,
      },
    };

    if (Object.keys(data).length) {
      packet.url += `${getDataFromObject(data)}`;
    }

    return request(packet);
  }

  static post(uri, apitoken, data = {}, headers = {}, params = {}) {
    headers['Accept'] = 'application/json';
    headers['Authorization'] = `Bearer ${apitoken}`;
    headers['Content-Type'] = 'application/json';

    if (uri[0] === '/') {
      uri = uri.substr(1);
    }

    let fullUri = `${env.VUE_APP_trimaster}/api/v1/${uri}?access_token=${apitoken}`;

    if (Object.keys(params).length) {
      fullUri += `${getDataFromObject(params)}`;
    }

    const packet = {
      data,
      method: 'POST',
      url: fullUri,
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${apitoken}`,
      },
    };

    return request(packet);
  }

  static patch(uri, apitoken, data) {
    if (uri[0] === '/') {
      uri = uri.substr(1);
    }

    const packet = {
      data,
      method: 'PATCH',
      url: `${env.VUE_APP_trimaster}/api/v1/${uri}?access_token=${apitoken}`,
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${apitoken}`,
        'Content-Type': 'application/json',
      },
    };

    return request(packet);
  }

  static put(uri, id, apitoken, data, filter = {}) {
    if (uri[0] === '/') {
      uri = uri.substr(1);
    }

    const packet = {
      data,
      method: 'PUT',
      url: `${env.VUE_APP_trimaster}/api/v1/${uri}/${id}?access_token=${apitoken}`,
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${apitoken}`,
        'Content-Type': 'application/json',
      },
    };

    if (Object.keys(filter).length) {
      packet.url += `${getDataFromObject(filter)}`;
    }

    return request(packet);
  }

  static destroy(uri, id, apitoken) {
    if (uri[0] === '/') {
      uri = uri.substr(1);
    }

    const packet = {
      method: 'DELETE',
      url: `${env.VUE_APP_trimaster}/api/v1/${uri}/${id}?access_token=${apitoken}`,
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${apitoken}`,
        'Content-Type': 'application/json',
      },
    };

    return request(packet);
  }

  static upsert(uri, apitoken, data) {
    if (uri[0] === '/') {
      uri = uri.substr(1);
    }

    const packet = {
      data,
      method: 'POST',
      url: `${env.VUE_APP_trimaster}/api/v1/${uri}/replaceOrCreate?access_token=${apitoken}`,
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${apitoken}`,
        'Content-Type': 'application/json',
      },
    };

    return request(packet);
  }

  static upsertWithWhere(uri, apitoken, whereExpr, data) {
    if (uri[0] === '/') {
      uri = uri.substr(1);
    }

    let whereExp = encodeURIComponent(JSON.stringify(whereExpr));

    const packet = {
      data,
      method: 'POST',
      url: `${env.VUE_APP_trimaster}/api/v1/${uri}/upsertWithWhere?where=${whereExp}&access_token=${apitoken}`,
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${apitoken}`,
        'Content-Type': 'application/json',
      },
    };

    return request(packet);
  }

  static displayMetric(user) {
    let pref = user.preferences.find((preference) => preference.preference === 'units');
    return pref.setting != 'imperial';
  }

  static isTrimaster() {
    if (location.href.indexOf('trigrow') >= 0 || location.href.indexOf('trimaster') >= 0) {
      return true;
    } else {
      return false;
    }
  }

  static isUserInRole(userInfo, role) {
    let roleNames = userInfo.roles.map((x) => x.name);
    return roleNames.includes(role);
  }

  static isAdmin(userInfo) {
    let roleIds = userInfo.roles.map((x) => x.id);
    return roleIds.includes(7) || roleIds.includes(5);
  }

  static isSoftwareDev(userInfo) {
    let roleIds = userInfo.roles.map((x) => x.id);
    return roleIds.includes(11);
  }

  static csvExport(aData, filename, apiToken, fields, includeSeconds) {
    let csvContent = '';

    let arrData = JSON.parse(JSON.stringify(aData)); // create clone

    if (fields) {
      let a = [];
      for (let i = 0; i < arrData.length; i++) {
        let rec = {};
        for (let j = 0; j < fields.length; j++) {
          rec[fields[j]] = arrData[i][fields[j]];
        }
        a.push(rec);
      }
      arrData = a;
    }

    for (let i = 0; i < arrData.length; i++) {
      for (let j in arrData[i]) {
        if (typeof arrData[i][j] == 'string') {
          let fieldValue = arrData[i][j];
          if (fieldValue.charAt(10) === 'T' && fieldValue[fieldValue.length - 1] === 'Z') {
            let formattedDate = null;
            if (!includeSeconds) {
              formattedDate = moment(fieldValue).format('MM/DD/YYYY h:mm a');
            } else {
              formattedDate = moment(fieldValue).format('MM/DD/YYYY h:mm:ss a');
            }
            if (formattedDate.indexOf('Inv') !== 0) {
              // check for invalid
              arrData[i][j] = formattedDate;
            }
          }
          arrData[i][j] = escapeCSVValue(arrData[i][j]);
          // arrData[i][j] = '"' + arrData[i][j] + '"';
        }
      }
    }
    csvContent += [Object.keys(arrData[0]).join(','), ...arrData.map((item) => Object.values(item).join(','))]
      .join('\n')
      .replace(/(^\[)|(\]$)/gm, '');
    csvContent = 'data:text/csv;charset=utf-8,' + csvContent;

    if (csvContent.length <= 2048) {
      // chrome limit is 2083

      csvContent = csvContent.replace(new RegExp('#', 'g'), ' ');

      const data = encodeURI(csvContent);
      const link = document.createElement('a');
      link.setAttribute('href', data);
      link.setAttribute('download', filename);
      link.click();
      link.remove();
    } else {
      // dynamically create temporary form and submit to reflector
      csvContent = Object.keys(arrData[0]).join(',');
      csvContent += String.fromCharCode(13);
      csvContent += String.fromCharCode(10);

      for (let i = 0; i < arrData.length; i++) {
        csvContent += Object.values(arrData[i]).join(',');
        csvContent += String.fromCharCode(13);
        csvContent += String.fromCharCode(10);
      }

      let form = document.createElement('form');
      form.setAttribute('action', `${env.VUE_APP_trimaster}/api/v1/utils/reflect?ACCESS_TOKEN=${apiToken}`);
      form.setAttribute('method', 'POST');
      form.setAttribute('style', 'display:none');
      form.innerHTML = `
        <input type="hidden" name="filename" value="${filename}">
        <input type="hidden" name="mimeType" value="text/csv">
        <textarea name="data">${csvContent}</textarea>
      `;

      document.body.appendChild(form);
      form.submit();
      setTimeout(function () {
        form.parentNode.removeChild(form);
      }, 500);
    }
  }

  static downloadContent(apiToken, filename, filecontents) {
    let form = document.createElement('form');
    form.setAttribute('action', `${env.VUE_APP_trimaster}/api/v1/utils/reflect?ACCESS_TOKEN=${apiToken}`);
    form.setAttribute('method', 'POST');
    form.setAttribute('style', 'display:none');
    form.innerHTML = `
            <input type="hidden" name="filename" value="${filename}">
            <input type="hidden" name="mimeType" value="text/csv">
            <textarea name="data">${filecontents}</textarea>
        `;

    document.body.appendChild(form);
    form.submit();
    setTimeout(function () {
      form.parentNode.removeChild(form);
    }, 500);
  }

  static isCannabisFacility() {
    let user = window.localStorage.getItem('user');

    user = JSON.parse(user);
    if (user && user.facility.growsCannabis) {
      return true;
    } else {
      return false;
    }
  }

  static isHempFacility() {
    let user = window.localStorage.getItem('user');

    user = JSON.parse(user);
    if (user && user.facility.growsHemp) {
      return true;
    } else {
      return false;
    }
  }

  static isLeafyGreensFacility() {
    let user = window.localStorage.getItem('user');
    user = JSON.parse(user);
    if (user && user.facility.growsLeafyGreens) {
      return true;
    } else {
      return false;
    }
  }

  static getFacilityWorkers(user, callback) {
    let where = {
      facility_id: user.facility_id,
      disabled: 0,
    };

    if (user.facilityname.indexOf('Agrify') == -1) {
      where.and = [
        { email: { nlike: '%trigrow.com' } },
        { email: { nlike: '%agrify.com' } },
        { email: { nlike: '%agrinamics.com' } },
        { email: { nlike: '%fabworksga.com' } },
        { email: { nlike: '%lightring.com' } },
        { email: { nlike: '%greendeath.us' } },
      ];
    }

    this.get('userFacilities', user.apitoken, {
      filter: {
        where: where,
        order: 'firstname',
      },
    }).then(function ([res, err]) {
      let result = [];
      for (let i = 0; i < res.length; i++) {
        result.push({
          name: res[i].firstname + ' ' + res[i].lastname,
          id: res[i].id,
          email: res[i].email,
          cellphone: res[i].cellphone,
          firstname: res[i].firstname,
          lastname: res[i].lastname,
        });
      }
      callback(result);
    });
  }

  static vuetifyGridSort(items, index, isDescending) {
    if (items.length > 0) {
      // locate first non-null value
      let sampleDataIndex = 0;
      for (let i = 0; i < items.length; i++) {
        if (items[i][index]) {
          sampleDataIndex = i;
          break;
        }
      }

      if (typeof items[sampleDataIndex][index] == 'number') {
        items.sort((a, b) => {
          let aVal = parseFloat(a[index]);
          let bVal = parseFloat(b[index]);

          if (isNaN(aVal)) {
            aVal = 0;
          }
          if (isNaN(bVal)) {
            bVal = 0;
          }

          if (isDescending) {
            return bVal - aVal;
          } else {
            return aVal - bVal;
          }
        });
      } else if (
        typeof items[sampleDataIndex][index] == 'string' &&
        items[sampleDataIndex][index].indexOf('.000Z') > 0 &&
        moment(items[sampleDataIndex][index]).isValid()
      ) {
        items.sort((a, b) => {
          let m1 = moment(a[index]);
          let m2 = moment(b[index]);

          if (isDescending) {
            if (m1.isValid() && m2.isValid()) {
              return m1.isBefore(m2) ? -1 : 1;
            } else {
              if (m1.isValid()) {
                return -1;
              } else {
                return 1;
              }
            }
          } else {
            if (m1.isValid() && m2.isValid()) {
              return m1.isBefore(m2) ? 1 : -1;
            } else {
              if (m1.isValid()) {
                return 1;
              } else {
                return -1;
              }
            }
          }
        });
      } else {
        items.sort((a, b) => {
          if (isDescending) {
            return a[index] > b[index] ? -1 : 1;
          } else {
            return a[index] > b[index] ? 1 : -1;
          }
        });
      }
    }
    return items;
  }

  static apiEndpoint() {
    return `${env.VUE_APP_trimaster}/api/v1/`;
  }
}
